import Fuse from 'fuse.js';
import csvDataRaw from 'bundle-text:./offers4.csv';
import { CSV } from './csv';
import { parseOfferDate } from '.';

const url = 'https://punchout.cloud/api/v1/files/AGVbSGrv7PdccfohqtCbJK?encoding=windows1252&from=2025-03-03';

let params = (new URL(window.location.href)).searchParams;
export let currency = 'MXN';

// console.log(csvDataRaw);


export interface Offer {
    incoterm: any;
    search_text: string;
    request_data: string;
    request_date: string;
    printed_offer: string;
    offer_date: string;
    offer_number: string;
    contact: string;
    customer_number: string;
    price_group: string;
    price: string;
    customer_name: string;
    shipping: string;
    currency: string;
    payment_terms: string;
    items: Product[];
    validity?: string;
}

export interface Product {
    packaging: any;
    lead_time: any;
    moq: any;
    price_unit: any;
    id: string;
    offer_number: string;
    sku: string;
    prices: { quantity: number, price: number }[];
    country_of_origin: any;
    incoterm: any;
    alternative: string;
    quantity: string;
    customer_article_number: string;
    delivery_time: string;
    unit: string;
    position_type: string;
    discount: string;
    search_name: string;
    description: string;
    price: number;
    article_type: string;
    article_number: string;
    origin_country: string;
    goods_number: string;
    currency: string;
    search_text: string;
    volume_discount: string;
    customer_name: string;
    customer_number: string;
    contact: string;
    offer_date: string;
    validity?: string;
}


function getNeighbor(data: string, i: number, dir: number, log = false): [string, number] {
    if (log) console.log("LOG", data[i]);
    i += dir;
    let char = data[i];
    while (true) {
        char = data[i];
        if (char == '\n' || char == '\r' || char == '\t' || char == ' ') {
            i += dir;
            continue;
        }
        if (char == '"') {
            const [neighbor, newIndex] = getNeighbor(data, i, dir, log);
            if (log) {
                console.log('found1', char, i, newIndex, neighbor);
            }
            if (neighbor == '"') {
                return ["''", i];
            }
            if (neighbor == ';') {
                return ["''", i];
                const [nextneighbor] = getNeighbor(data, newIndex, dir, log);
                if (log) {
                    console.log('found2', char, i, newIndex, neighbor, nextneighbor);
                }
                if (nextneighbor != '"' && nextneighbor != ';') {
                    return ["''", i];
                }
                /*const [neighbor] = getNeighbor(data, newIndex, dir);
                if (neighbor !== '"') {
                    return ["''", i];
                }*/
            }
        }

        if (false && char == ';') {
            const [nextneighbor] = getNeighbor(data, i, dir, log);
            if (nextneighbor != '"' && nextneighbor != ';' && nextneighbor != undefined) {
                return ["''", i];
            }
            /*const [neighbor] = getNeighbor(data, newIndex, dir);
            if (neighbor !== '"') {
                return ["''", i];
            }*/
        }


        if (log) console.log("LOG", char);

        return [char, i];
    }
}

async function parseCSV(csvDataRaw: string) {

    let csvData = csvDataRaw
        .replace(/At01Staffelpreise/g, 'volume_discount')
        .replace(/An02Lieferzeit/g, 'lead_time')
        .replace(/At01MinBestellmenge/g, 'moq')
        .replace(/At01Verpackungseinh/g, 'packaging')
        .replace(/At01MengenSchl/g, 'price_unit')
        .replace(/An01AnfrageDaten/g, 'request_data')
        .replace(/An01AnfrageDatum/g, 'request_date')
        .replace(/An01AngebotGedruckt/g, 'printed_offer')
        .replace(/An01AngebotsDatum/g, 'offer_date')
        .replace(/An01AngebotsNr/g, 'offer_number')
        .replace(/An01Ansprechpartner/g, 'contact')
        .replace(/An01Gueltigkeit/g, 'validity')
        .replace(/An01Incoterm/g, 'incoterm')
        .replace(/An01KundenNr/g, 'customer_number')
        .replace(/An01PreisGrp/g, 'price_group')
        .replace(/An01Suchname/g, 'customer_name')
        //.replace(/An01Verpackung/g, 'packaging')
        .replace(/An01Versand/g, 'shipping')
        .replace(/An01Waehrung/g, 'currency')
        .replace(/Zb01Bezeichnung/g, 'payment_terms')
        .replace(/An02Alternativ/g, 'alternative')
        .replace(/An02AngebotsMenge/g, 'quantity')
        .replace(/An02Bezeichnung1/g, 'sku')
        .replace(/An02KundenArtikelNr/g, 'customer_article_number')
        .replace(/An02Lieferzeit/g, 'delivery_time')
        .replace(/An02MengenBez/g, 'unit')
        .replace(/An02PosArt/g, 'position_type')
        .replace(/An02Rabatt/g, 'discount')
        .replace(/An02Suchname/g, 'search_name')
        .replace(/An02Text/g, 'description')
        .replace(/An02VkPreis/g, 'price')
        .replace(/At01ArtikelArt/g, 'article_type')
        .replace(/At01ArtikelNr/g, 'article_number')
        //.replace(/At01UrsprungLand/g, 'country_of_origin')
        .replace(/At01WarenNr/g, 'goods_number')
        .replace(/Ld01Bezeichnung/g, 'country_of_origin')
        //.replace(/Zb01Bezeichnung/g, 'description')
        .replace(/\r/g, '');


    csvData = csvData.split('').map((it, i) => {

        // const log = csvData[i - 1] == '2' && csvData[i - 2] == '/' && csvData[i - 3] == '1';
        const [previous] = getNeighbor(csvData, i, -1);

        const [next] = getNeighbor(csvData, i, 1);
        /*if (log) {
            console.log("PREVNEXT", previous, next);
        }*/
        if (it == '"' && !(previous == ';' || previous == '"' || previous == undefined || next == ';' || next == '"' || next == undefined)) {
            //   console.log('replacing', i, it, previous, next);
            return "''";
        }
        return it;
    }).join('');

    //console.log("AFTER", csvData)

    const lines = CSV.csvToObject(csvData, { trim: true, delimeter: ';' });

    // console.log(lines);

    const offers = lines
        .filter(it => it.description)
        .reduce((acc: any, line: any) => {

            if (!acc[line.offer_number]) {
                acc[line.offer_number] = {
                    ...line,
                    items: []
                };
            }
            acc[line.offer_number].items.push(line);
            return acc;
        }, {});


    Object.keys(offers).forEach((key) => {
        offers[key].items = Object.values(offers[key].items.reduce((acc: any, line: any) => {
            const id = getUniqueId(line);
            line.id = id;
            line.unit = line.unit || 'Pce';
            line.volume_discount = line.volume_discount == "Wahr";
            if (!acc[id]) {
                acc[id] = {
                    ...line,
                    prices: []
                };
            }
            acc[id].prices.push({ quantity: line.quantity, price: parseFloat(line.price?.replace('.', '')?.replace(',', '.')) });
            acc[id].prices.sort((a: { quantity: number }, b: { quantity: number }) => a.quantity - b.quantity);
            return acc;
        }, {}));
    });


    OffersList = Object.values(offers);
    OffersList.forEach(it => it.search_text = it.items.map(it => {
        it.search_text = [it.offer_number, it.sku, it.search_name, it.description, it.sku, it.article_number, it.customer_article_number].join(' ');
        return it.search_text;
    }).join(' ').toLowerCase());



    ArticlesList = OffersList.map(offer => offer.items.filter(it => it.article_type == 'W')).reduce((p, n) => p.concat(n), []);

}

export let OffersList: Offer[] = [];
export let ArticlesList: Product[] = [];



export function currencySymbol(currency: string) {

    return { 'USD': '$', 'EUR': '€', 'MXN': 'MX$' }["EUR"] || currency;
}

export function getCartItemPrice(item: CartItem) {
    return getItemPrice(item.product, item.quantity) || 0;
}

export interface CartItem {
    product: Product,
    quantity: number,
};

export class Cart {
    items: CartItem[] = [];
}

export class Model {

    cartClass = '';
    search: string = '';
    filter: any = {};

    products: Product[] = ArticlesList;


    cart = new Cart();

    filters = {
        request_date: "",
        customer_number: "",
        customer_name: "",
        contact: "",
    }


    offers: Offer[] = []



    constructor() {
        if (localStorage.getItem('cart')) {
            this.cart = JSON.parse(localStorage.getItem('cart') as any);
        }

    }

    load(dispatch) {
        fetch(url).then(response => response.json()).then(data => {
            const csvs = csvDataRaw + '\n' + data.data.map((it: any) => it.data)
                .map((c, i) => {
                    const list = c.split('\n');
                    list.shift();
                    return list.join('\n');
                }).join('\n');
            parseCSV(csvs).then(() => {
                console.log('CSV parsed');
                this.offers = OffersList;
                dispatch({ type: 'products', products: ArticlesList });
            });
        });
    }
}


export type Action
    = { type: 'add', product: Product, quantity: number }
    | { type: 'remove', product: Product }
    | { type: 'quantity', id: string, quantity: number }
    | { type: 'products', products: Product[] }
    | { type: 'filter', filter: any }
    | { type: 'filter.in', key: string, option: string, value: boolean }
    | { type: 'search', value: string }
    | { type: 'filter.clear' }
    | { type: 'cart.clear' }
    | { type: 'endanimate' }
    | { type: 'filter.add', key: string, value: string }
    | { type: 'filter.remove' }
    | { type: 'offers.fetch' };


let fuse = new Fuse<Product>([]);
//let fuseOffers = new Fuse<Offer>(OffersList, { keys: ['search_text', 'sku', 'customer_article_number', 'customer_name', 'offer_number'], findAllMatches: true, threshold: 0.3 });

export function RootReducer(state: Model, action: Action) {
    console.log(action);
    switch (action.type) {
        case 'offers.fetch':
            /*if (state.filters.contact === "" && state.filters.customer_name === "" && state.filters.customer_number === "" && state.filters.request_date === "") {
                state.offers = searchText(state.search, OffersList);
            } else {
                state.offers = searchText(state.search, OffersList).filter(it => {
                    return Object.keys(state.filters).every(key => {
                        // If the filter value is empty, skip it (do not apply that filter)
                        if (state.filters[key] === "") return true;
                        // Otherwise, ensure the product's value matches the filter's value
                        return it[key] === state.filters[key];
                    });
                });;
            }*/
            break;
        case 'cart.clear':
            state.cart.items = [];
            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'filter.clear':
            state.search = '';
            state.filter = {};
            break;
        case 'search':
            state.search = action.value;
            break;
        case 'add':
            const item = state.cart.items.find(it => it.product.id == action.product.id);
            if (item) {
                item.quantity += action.quantity;
            } else {
                const newCartItem = { product: action.product, quantity: action.quantity };
                state.cart.items.push(newCartItem);
            }
            state.cartClass = 'animate__animated animate__headShake';

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'quantity':
            // update quantity
            state.cart.items.filter(it => it.product.id == action.id).forEach(it => {
                it.quantity = action.quantity;
            });
            // remove if quantity is 0
            state.cart.items = state.cart.items.filter(it => it.quantity);

            localStorage.setItem('cart', JSON.stringify(state.cart));
            break;
        case 'products':
            state.products = [...action.products];
            fuse = new Fuse(state.products, { keys: ['name', 'sku', 'description'], findAllMatches: true, threshold: 0.4 });
            break;
        case 'filter':
            state.filter = action.filter;
            break;
        case 'filter.in':
            state.filter[action.key] = state.filter[action.key] || [];
            if (action.value) {
                state.filter[action.key].push(action.option);
            } else {
                state.filter[action.key] = state.filter[action.key].filter(it => it !== action.option);
            }
            if (state.filter[action.key].length == 0) {
                delete state.filter[action.key];
            }
            break;
        case 'filter.add':
            state.filters[action.key] = action.value;
        /*state.offers = searchText(state.search, OffersList).filter(it => {
            return Object.keys(state.filters).every(key => {
                // If the filter value is empty, skip it (do not apply that filter)
                if (state.filters[key] === "") return true;
                // Otherwise, ensure the product's value matches the filter's value
                return it[key] === state.filters[key];
            });
        });*/
        // return { ...state };
        case 'endanimate':
            state.cartClass = '';
            break;
        default:
            break;
    }
    return { ...state };
}




export function getItemPrice(item: Product, quantity: number) {
    if (item.prices.length == 0) return null;
    if (item.prices.length == 1 || !item.volume_discount) {
        return item.prices[0].price
    }
    const prices = item.prices.filter(it => it.quantity <= (quantity || 0));
    return prices.pop()?.price;
}

export function getMOQ(item: Product): number {
    if (item.prices.length == 0) return 0;
    if (item.moq) return parseInt(item.moq.toString());
    const moq = parseInt(item.prices[0].quantity.toString());
    const packaging = getPackaging(item);
    return moq < packaging ? packaging : moq;
}

export function getPackaging(item: Product): number {
    if (item.prices.length == 0) return 1;
    if (item.packaging) return parseInt(item.packaging.toString());
    return 1;
}


export function search(state: Model) {

    let products = state.products;

    if (state.search) {
        products = fuse.search(state.search).map(it => it.item);
    }

    return products.filter(product => {
        for (const key in state.filter) {
            const value = state.filter[key];
            if (value == undefined) {
                continue;
            } else if (Array.isArray(value)) {
                if (value.includes(product[key])) {
                    continue;
                }
            } else if (value == product[key]) {
                continue;
            }
            return false;
        }
        return true;
    });
}


export function searchText<T extends { search_text: string, customer_name: string, customer_number: string, contact: string, offer_date: string, validity?: string }>(state_search: string, filters: any, items: T[] , isOffer: boolean = false) {
    const q = state_search?.toLowerCase();
    const filtered = items.filter(it => {
        if (filters.customer_name && filters.customer_name.length > 0) {
            if (!filters.customer_name.includes(it.customer_name)) {
                return false;
            }
        }
        if (filters.customer_number && filters.customer_number.length > 0) {
            if (!filters.customer_number.includes(it.customer_number)) {
                return false;
            }
        }

        if (filters.contact && filters.contact.length > 0) {
            if (!filters.contact.includes(it.contact)) {
                return false;
            }
        }

        const offer_date_date = parseOfferDate(it.offer_date);
        let offer_date = `${offer_date_date.getFullYear()}-${(offer_date_date.getMonth() + 1).toString().padStart(2, '0')}-${offer_date_date.getDate().toString().padStart(2, '0')}`;

        if (filters.offer_date_from) {
            if (offer_date < filters.offer_date_from) {
                console.log(offer_date, filters.offer_date_from);
                return false;
            }
        }

        if (filters.offer_date_to) {
            if (offer_date > filters.offer_date_to) {
                console.log(offer_date, filters.offer_date_to);
                return false;
            }
        }

        if (q) {
            return it.search_text.includes(q);
        }
        return true;

    });

    // only sort offers
    if (!isOffer) {
        return filtered;
    }

     // do not sort if date filters are applied
    if (filters.offer_date_from || filters.offer_date_to) {
        return filtered;
    }

    
    return filtered.sort((a, b) => {
        console.log(a, b);
        const da = parseOfferDate(a?.validity || '');
        const db = parseOfferDate(b?.validity || '');
        return db.getTime() - da.getTime();
    });
}

const hash = (str: any) => {
    if (typeof (str) !== 'string') {
        str = JSON.stringify(str);
    }
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([hash])[0].toString(36);
};


export function getUniqueId(item: Product) {
    if (item.article_number == "DIVERS") {
        return item.offer_number + '-' + item.article_number + '-' + item.description;
    } else {
        return item.offer_number + '-' + item.article_number;
    }
}